import styled from 'styled-components';

export const StyledAnimatedLoaderInitialAnimation = styled.div`
  position: absolute;
  display: flex;
  animation: rotate-center-fade-out-shrink 3s ease-in-out both;
  @keyframes rotate-center-fade-out-shrink {
    0% {
      transform: rotate(0);
      opacity: 1;
    }
    25% {
      transform: rotate(0);
      opacity: 1;
    }
    50% {
      opacity: 0;
      transform: rotate(180deg) scale(0.4);
    }
    100% {
      opacity: 0;
      transform: rotate(180deg) scale(0.4);
    }
  }
`;
export const StyledAnimatedLoaderInitialAnimationSingleStar = styled.div`
  position: absolute;
  display: flex;
  opacity: 0;
  animation: rotate-center-fade-in 3s ease-in-out both;
  @keyframes rotate-center-fade-in {
    0% {
      transform: rotate(0) scale(2);
      opacity: 0;
    }
    25% {
      transform: rotate(0) scale(2);
      opacity: 0;
    }
    50% {
      opacity: 1;
      transform: rotate(180deg);
    }
    100% {
      opacity: 1;
      transform: rotate(180deg);
    }
  }
`;
export const StyledAnimatedLoaderLoadingAnimationSingleStar = styled.div`
  position: absolute;
  display: flex;
  animation: rotate-center-fade-out-fade-in 2s ease-in-out both infinite;
  @keyframes rotate-center-fade-out-fade-in {
    0% {
      transform: rotate(0deg);
      opacity: 1;
    }
    20% {
      opacity: 0.3;
    }
    40% {
      transform: rotate(180deg);
      opacity: 1;
    }
    100% {
      transform: rotate(180deg);
      opacity: 1;
    }
  }
`;
export const StyledAnimatedLoaderEndingAnimation = styled.div`
  position: absolute;
  display: flex;
  animation: rotate-center-fade-in-expand 3s ease-in-out both;
  @keyframes rotate-center-fade-in-expand {
    0% {
      transform: rotate(180deg) scale(0.5);
      opacity: 0;
    }
    20% {
      transform: rotate(180deg) scale(0.5);
      opacity: 0;
    }
    40% {
      opacity: 1;
      transform: rotate(360deg);
    }
    100% {
      opacity: 1;
      transform: rotate(360deg);
    }
  }
`;
export const StyledAnimatedLoaderEndingAnimationSingleStar = styled.div`
  position: absolute;
  display: flex;
  animation: rotate-center-fade-out 3s ease-in-out both;
  @keyframes rotate-center-fade-out {
    0% {
      transform: rotate(0);
      opacity: 1;
    }
    20% {
      transform: rotate(0);
      opacity: 1;
    }
    40% {
      opacity: 0;
      transform: rotate(180deg) scale(2);
    }
    100% {
      opacity: 0;
      transform: rotate(180deg) scale(2);
    }
  }
`;
